import axios from "axios";
import AxiosClient from "../../../services/axios.services";

class ReasonsForAbsenceServices {
  getReasonsForAbsence = params =>
    AxiosClient.get("/api/app/capacitacion_motivo_inasistencia/", {
      headers: { "Content-Type": "application/json" },
      params: params,
   });
  getReasonForAbsence = id =>
    AxiosClient.get(`/api/app/capacitacion_motivo_inasistencia/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  saveReasonsForAbsence = data =>
    AxiosClient.post("/api/app/capacitacion_motivo_inasistencia/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editReasonsForAbsence = (id, data) =>
    AxiosClient.put(
      `/api/app/capacitacion_motivo_inasistencia/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteReasonsForAbsence = id =>
    AxiosClient.delete(`/api/app/capacitacion_motivo_inasistencia/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new ReasonsForAbsenceServices();